import React from "react";
import { LoadingIndicator } from "@jsq/ds/core";
import { useGetDetailedPaymentPrefQuery } from "#graphql/supergraphHooks";
import { clientContext } from "#utils/graphql_utils";
import { PaymentPrefDetails } from "../PaymentPrefDetails";
import { type ExistingPaymentPrefDetailsProps } from "./types";
export const ExistingPaymentPrefDetails: React.FC<ExistingPaymentPrefDetailsProps> = ({
  paymentPrefId,
  visibleFields,
  showBankDomicile,
  checkDisplayOverride,
}: ExistingPaymentPrefDetailsProps) => {
  const { data, loading, error } = useGetDetailedPaymentPrefQuery({
    variables: {
      id: paymentPrefId,
    },
    fetchPolicy: "network-only",
    context: clientContext(),
  });

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return null;
  }

  if (
    !data?.paymentPrefs ||
    data?.paymentPrefs.length === 0 ||
    !data.paymentPrefs[0].paymentPrefFull
  ) {
    return null;
  }

  const { paymentPrefFull } = data.paymentPrefs[0];

  return (
    <PaymentPrefDetails
      paymentPrefFull={paymentPrefFull}
      visibleFields={visibleFields}
      showBankDomicile={showBankDomicile}
      checkDisplayOverride={checkDisplayOverride}
    />
  );
};
